var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',[_c('span',{staticClass:"ada-tooltip"},[_vm._v("captcha response")]),_c('div',{attrs:{"id":'captcha-div_' + _vm.id}})])}
var staticRenderFns = []

export { render, staticRenderFns }